export const API = {
  WAREHOUSE: {
    TYPE: 'GET',
    URL: `/novapost/warehouses/by-city`,
  },
};

export interface WAREHOUSE_ITEM_DATA_RAW_INTER {
  id: number;
  ref: string;
  cityRef: string;
  cityDescription: string;
  cityDescriptionRu: string;
  number: number;
  description: string;
  descriptionRu: string;
  shortAddress: string;
  shortAddressRu: string;
  typeOfWarehouse: string;
  categoryOfWarehouse: string;
  latitude: string;
  longitude: string;
  phone: string;
  postFinanceCode: string | null;
  reception: boolean;
  delivery: boolean;
  syncedAt: string;
}

export type WAREHOUSE_LIST_RAW_INTER = WAREHOUSE_ITEM_DATA_RAW_INTER[];
